import { render, staticRenderFns } from "./c_hot_menu.vue?vue&type=template&id=48b6eb44&scoped=true"
import script from "./c_hot_menu.vue?vue&type=script&lang=js"
export * from "./c_hot_menu.vue?vue&type=script&lang=js"
import style0 from "./c_hot_menu.vue?vue&type=style&index=0&id=48b6eb44&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b6eb44",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qingchi/workspace/mimi/mer_mer_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48b6eb44')) {
      api.createRecord('48b6eb44', component.options)
    } else {
      api.reload('48b6eb44', component.options)
    }
    module.hot.accept("./c_hot_menu.vue?vue&type=template&id=48b6eb44&scoped=true", function () {
      api.rerender('48b6eb44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PageDiy/mobileConfigRight/c_hot_menu.vue"
export default component.exports